<template>
  <div-box :src="require('../../assets/img/shequn_bg@2x.png')">
    <wallet-head show_type="5" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.list.data" :noToken="false"
      url="/api/v1/user/team" :data="{}">
      <div-padding padding="4vw">
        <div-card radius="2vw" bg='rgba(255, 215, 145, 0.4)' padding='2vw 3vw'>
          <div-flex>
            <div-width width='80vw'>
              <div-text color='#fff' one size='3.5vw'>{{ $t('推广链接') }}：{{ url }}</div-text>
            </div-width>

            <div-img width='4vw' height='4vw'>
              <img src='../../assets/img/fuzhi@2x.png' @click="copyData(url)" />
            </div-img>
          </div-flex>
        </div-card>
        <div-height height='6vw' />
        <div-flex br>
          <div-card margin="0 0 3vw 0" bg='#242424' width="45vw" height="21vw" padding='3vw'
            @click="router('quanyi_list')">
            <div-text color='#fff' align="center" size='6vw'>{{ info.equity }}</div-text>
            <div-height height='1vw' />
            <div-text color='#999' align="center" size='3vw'>{{ $t('权益值') }}</div-text>
          </div-card>
          <div-card margin="0 0 3vw 0" bg='#242424' width="45vw" height="21vw" padding='3vw'>
            <div-text color='#fff' align="center" size='6vw'>{{ info.bonus_radio }}</div-text>
            <div-height height='1vw' />
            <div-text color='#999' align="center" size='3vw'>{{ $t('分红点') }}</div-text>
          </div-card>
          <div-card bg='#242424' width="45vw" height="21vw" padding='3vw'>
            <div-text color='#fff' align="center" size='6vw'>{{ info.personal_performance }}</div-text>
            <div-height height='1vw' />
            <div-text color='#999' align="center" size='3vw'>{{ $t('我的贡献') }}</div-text>
          </div-card>
          <div-card bg='#242424' width="45vw" height="21vw" padding='3vw'>
            <div-flex center>
              <div-img width='20vw' height='9vw'>
                <img src='../../assets/img/dengji0.png' v-if="info.level == 0" />
                <img src='../../assets/img/dengji1.png' v-if="info.level == 1" />
                <img src='../../assets/img/dengji2.png' v-if="info.level == 2" />
                <img src='../../assets/img/dengji3.png' v-if="info.level == 3" />
                <img src='../../assets/img/dengji4.png' v-if="info.level == 4" />
                <img src='../../assets/img/dengji5.png' v-if="info.level == 5" />
                <img src='../../assets/img/dengji6.png' v-if="info.level == 6" />
                <img src='../../assets/img/dengji7.png' v-if="info.level == 7" />
                <img src='../../assets/img/dengji8.png' v-if="info.level == 8" />
                <img src='../../assets/img/dengji9.png' v-if="info.level == 9" />
              </div-img>
            </div-flex>
            <div-height height='1vw' />
            <div-text color='#999' align="center" size='3vw'>{{ $t('级别') }}</div-text>
          </div-card>
        </div-flex>
        <div-height height='3vw' />

        <div-card bg="rgba(35, 35, 35,0.4)">
          <div-flex br>
            <div-width width='40vw' style="margin-bottom: 15px;">
              <div-text color='#fff' align="center" size='6vw'>{{ info.team_num }}</div-text>
              <div-height height='1vw' />
              <div-text color='#999' align="center" size='3vw' center>{{ $t('团队人数') }}</div-text>
            </div-width>
            <div-width width='40vw' style="margin-bottom: 15px;">
              <div-text color='#fff' align="center" size='6vw'>{{ info.direct_num }}</div-text>
              <div-height height='1vw' />
              <div-text color='#999' align="center" size='3vw' center>{{ $t('直推人数') }}</div-text>
            </div-width>
            <div-width width='40vw' style="margin-bottom: 15px;">
              <div-text color='#fff' align="center" size='6vw'>{{ info.team_performance_total }}</div-text>
              <div-height height='1vw' />
              <div-text color='#999' align="center" size='3vw' center>{{ $t('节点团队业绩') }}</div-text>
            </div-width>
            <div-width width='40vw' style="margin-bottom: 15px;">
              <div-text color='#fff' align="center" size='6vw'>{{ info.licai_tuan_dui_1 }}</div-text>
              <div-height height='1vw' />
              <div-text color='#999' align="center" size='3vw' center>{{ $t('理财团队一月内业绩') }}</div-text>
            </div-width>
            <div-width width='40vw'>
              <div-text color='#fff' align="center" size='6vw'>{{ info.licai_tuan_dui_2 }}</div-text>
              <div-height height='1vw' />
              <div-text color='#999' align="center" size='3vw' center>{{ $t('理财团队一月以上业绩') }}</div-text>
            </div-width>
          </div-flex>
        </div-card>
        <div-padding padding="4vw 0">
          <div-flex left>
            <div-img width='4vw' height='4vw'>
              <img src="../../assets/img/zujian@2x.png" alt="">
            </div-img>
            <div-width width='1vw' />
            <div-text color='#fff' size='4vw'>{{ $t('我的推荐') }}</div-text>
          </div-flex>
        </div-padding>
        <div-card bg='#242424' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-flex left>
              <div-text color='#CEB082' size='4vw'>{{ item.team_performance_total }}</div-text>
              <div-text color='#999' size='4vw'>{{ $t('贡献值') }}</div-text>
            </div-flex>
            <div-img width='20vw' height='5vw'>
              <img src='../../assets/img/dengji0.png' v-if="item.level == 0" />
              <img src='../../assets/img/dengji1.png' v-if="item.level == 1" />
              <img src='../../assets/img/dengji2.png' v-if="item.level == 2" />
              <img src='../../assets/img/dengji3.png' v-if="item.level == 3" />
              <img src='../../assets/img/dengji4.png' v-if="item.level == 4" />
              <img src='../../assets/img/dengji5.png' v-if="item.level == 5" />
              <img src='../../assets/img/dengji6.png' v-if="item.level == 6" />
              <img src='../../assets/img/dengji7.png' v-if="item.level == 7" />
              <img src='../../assets/img/dengji8.png' v-if="item.level == 8" />
              <img src='../../assets/img/dengji9.png' v-if="item.level == 9" />
            </div-img>
          </div-flex>
          <div-height height='2vw' />
          <div-text color='#999' size='3vw'>{{ $t('账号') }}：{{ item.account }}</div-text>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        info: {},
        list: [],
        url: "",
      }
    },
    created() {
      this.get_info()
      this.getdata() //获取推广链接
      this.up_down()
    },
    methods: {
      getdata() {
        this.$get({
          url: "/api/v1/user/info",
          success: (res) => {
            this.url = `${window.location.origin}/h5/#/?code=${res.data.invite_code}`
          },
          tip: () => { },
        })
      },
      get_info() {
        this.$get({
          url: "/api/v1/user/team",
          success: (res) => {
            this.info = res.data
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped></style>